import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  GetEventRequest,
  GetEventsByPeriodRequest,
} from '@myStore/events-view/events-view.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { EventsService } from '@services/events/events.service';
import { QueryParamsService } from '@services/query-params/query-params.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, switchMap } from 'rxjs/operators';
import { IAppState } from '../app.state';
import {
  AddEvent,
  AddEventFailure,
  AddEventMaterial,
  AddEventMaterialFailure,
  AddEventMaterialSuccess,
  AddEventSuccess,
  AddEventVisits,
  AddEventVisitsFailure,
  AddEventVisitsSuccess,
  DeleteEventFile,
  DeleteEventFileFailure,
  EEventsActions,
  GetEventVisits,
  GetEventVisitsFailure,
  GetEventVisitsSuccess,
} from './events.actions';

@Injectable()
export class EventsEffects {
  constructor(
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _events_service: EventsService,
    private _router: Router,
    private _toastr: ToastrService,
    private _qpService: QueryParamsService
  ) {}

  $addEventMaterial = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<AddEventMaterial>(EEventsActions.AddEventMaterial),
        map(action => action),
        switchMap(action => {
          return this._events_service
            .addEventMaterial(
              action.eventMaterial.eventId,
              action.eventMaterial.type
            )
            .pipe(
              map(response => {
                window.open('/materials/' + response.id);
                this._store.dispatch(new AddEventMaterialSuccess(response.id));
                this._store.dispatch(
                  new GetEventRequest(action.eventMaterial.eventId)
                );
              }),
              catchError(err => {
                this._toastr.error(
                  `При добавлении материала возникла ошибка (post)`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(new AddEventMaterialFailure());
                this._toastr.error(err.error[0]);
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $addEvent = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<AddEvent>(EEventsActions.AddEvent),
        map(action => action),
        switchMap(action => {
          return this._events_service.createEvent(action.event).pipe(
            map(response => {
              this._toastr.success(response.detail);
              if (action.period) {
                this._store.dispatch(
                  new GetEventsByPeriodRequest(action.period)
                );
                this._router.navigate([`events/${response.id}`]);
              } else {
                this._store.dispatch(new GetEventRequest(response.id));
                window.open(`events/${response.id}`, '_blank');
              }
              this._store.dispatch(new AddEventSuccess());
            }),
            catchError(err => {
              this._toastr.error(
                `При добавлении события возникла ошибка (post)`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new AddEventFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $deleteEventFile = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<DeleteEventFile>(EEventsActions.DeleteEventFile),
        map(action => action),
        switchMap(action => {
          return this._events_service.deleteEventFile(action.event_id).pipe(
            map(() => {
              this._store.dispatch(new GetEventRequest(action.eventId));
              this._toastr.success('Файл успешно удален');
            }),
            catchError(err => {
              this._toastr.error(
                `При удалении файла возникла ошибка (delete)`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new DeleteEventFileFailure());
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $addEventVisits = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<AddEventVisits>(EEventsActions.AddEventVisits),
        map(action => action),
        switchMap(action => {
          return this._events_service
            .addEventVisits(action.id, action.students)
            .pipe(
              map(() => {
                if (action.options?.changeParams) {
                  this._qpService.changeQueryParams(
                    action.options?.changeParams
                  );
                }
                this._toastr.success('Отметка посещаемости успешно сохранена');
                this._store.dispatch(new AddEventVisitsSuccess());
              }),
              catchError(err => {
                this._store.dispatch(new AddEventVisitsFailure());
                this._toastr.error(
                  `${err?.error?.detail ? err?.error?.detail : ''}`,
                  'Не удалось сохранить посещаемость, повторите попытку.',
                  { timeOut: 3500 }
                );
                return err.error;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $getEventVisits = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetEventVisits>(EEventsActions.GetEventVisits),
        map(action => action),
        switchMap(action => {
          return this._events_service.getEventVisits(action.id).pipe(
            map(res => {
              const users: number[] = [];

              res.visits.forEach(user => {
                if (user.id) {
                  users.push(user.id);
                }
              });

              this._store.dispatch(new GetEventVisitsSuccess(users));
            }),
            catchError(err => {
              this._store.dispatch(new GetEventVisitsFailure());
              this._toastr.error(
                `${err?.error?.detail ? err?.error?.detail : ''}`,
                'Не удалось получить посещаемость, повторите попытку.',
                { timeOut: 3500 }
              );
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );
}
